import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/overview/ai-studio";

export const Route = createFileRoute("/admin/_overview/ai-studio")({
  component: Page,
});
